import React, { useRef, useState } from 'react';
import MaleT from "../Assets/Timelapse.mp4";
import { Link } from "react-router-dom";
import "../Styles/HomePage.css";

function Home() {
    const maleVideoRef = useRef(null);
    const [isMaleVideoPlaying, setIsMaleVideoPlaying] = useState(false);

    const toggleMaleVideoPlay = () => {
        if (maleVideoRef.current) {
            if (maleVideoRef.current.paused) {
                maleVideoRef.current.play();
                setIsMaleVideoPlaying(true);
            } else {
                maleVideoRef.current.pause();
                setIsMaleVideoPlaying(false);
            }
        }
    };

    return (
        <div className="home">
            <header className="header">
                <h1>Bring your BeReal memories to life!</h1>
            </header>
            <body className="body">
                <div className="leftside">
                    <h2 className="description">
                        Our site uses your BeReal data to create a seamless timelapse, allowing you to relive your memories in motion.
                    </h2>
                    <Link to="/Upload">
                    <button className="button">Create my Timelapse!</button>
                    </Link>
                </div>
                <div className="rightside">
                    <video 
                        ref={maleVideoRef}
                        className="maleV"
                        src={MaleT}
                        loop
                        playsInline
                        autoPlay 
                        muted 
                    />
                    <button 
                        className="VideoPlayPauseButton" 
                        onClick={toggleMaleVideoPlay}>
                        {isMaleVideoPlaying ? (
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
                                <rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/>
                            </svg>
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M8 5v14l11-7z"/>
                            </svg>
                        )}
                    </button> 
                </div>    
            </body>
        </div>

    )
}

export default Home;